import { makeStyles } from 'tss-react/mui';

const useStylesTableResize: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  tableResizeContainer: {
    position: 'relative',
    height: 0,
    width: 0,
  },
  tableResizeHandleBlock: {
    display: 'inline-flex',
    zIndex: 1000,
  },
  tableResizeHandle: {
    position: 'relative',
    width: 0,
    height: '100%',
    marginLeft: -1,
    left: 0,
    cursor: 'ew-resize',
    border: `1px solid ${theme.palette.info.main}`,
  },
}));

export default useStylesTableResize;
